import React from "react";
import { node } from "prop-types";

const Tbody = ({ children, ...props }) => {
	return <tbody {...props}>{children}</tbody>;
};

Tbody.propTypes = {
	children: node.isRequired,
};

export default Tbody;
